import type { SortingState } from '@tanstack/react-table';

export const BROWSE_PAGE_SIZE = 100;

export interface CursorPagination {
  limit: number;
  offset: 0;
  total: null;
  next_cursor: string | null;
  has_more: boolean;
  as_of: string;
}

export interface ApiBrowseSummary {
  total: number;
  new_count: number;
  as_of: string;
  data_version: string;
}

export function firstServerSort(
  sorting: SortingState,
  fallback: { id: string; desc: boolean },
  allowlist?: readonly string[],
): { sort: string; direction: 'asc' | 'desc' } {
  const first = sorting[0] ?? fallback;
  if (allowlist && !allowlist.includes(first.id)) {
    return { sort: fallback.id, direction: fallback.desc ? 'desc' : 'asc' };
  }
  return { sort: first.id, direction: first.desc ? 'desc' : 'asc' };
}
